import {useContext} from 'react'

import Context from '@s-ui/react-context'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

export const useSuggesterTracking = () => {
  const {domain} = useContext(Context)
  const {track, page} = useAnalyticsTrack()
  const getTrackingData = async ({action, pageName, selectedOption}) => {
    const [error, response] = await domain.get('get_vehicle_suggester_event_tracking_data_use_case').execute({
      action,
      pageName,
      selectedOption
    })
    // The use case resolves to `[error, null]` on a rejected tracking payload — e.g. the
    // makes step legitimately allows submitting with no make chosen, and the tracking VO
    // requires `selectedOption` for NEXT_BUTTON_CLICKED. Dereferencing `response` there
    // threw an uncaught TypeError out of the page. Analytics must never break rendering.
    if (error) {
      console.error(error)
      return null
    }
    return response.toSegmentTrack()
  }

  const trackPage = async pageName => {
    const pageTrackingData = await domain.get('get_page_tracking_data_use_case').execute({
      page: pageName
    })
    page(pageTrackingData)
  }

  const trackAction = async ({action, pageName, selectedOption}) => {
    const trackingData = await getTrackingData({action, pageName, selectedOption})
    if (!trackingData) return
    track({event: trackingData.event, data: trackingData.data})
  }

  return {trackAction, trackPage}
}
